import { makeStyles } from "@material-ui/core";

const style = makeStyles((theme) => ({
  toggler: {
    color: theme.colors.black,
    fontStyle: "italic",
    "&:hover": { fontWeight: "bold" },
    "&:active": { color: theme.colors.offWhite },
  },
  blackText: { color: theme.colors.black },
  whiteText: { color: theme.colors.offWhite },
  box: { marginBottom: theme.spacing(1) },
  button: { "&:hover": { fontWeight: "bold" } },
}));

export default style;
